import React, { useContext, useEffect, useState } from 'react'
import { notify, urlApiPlamin } from '../../utils/utils'
import { Fetch } from '../../services/api'
import { UserContext } from '../../context/provider/UserProvider'

export const useCentroMonitoreo = () => {

  const [arregloEmpresas, setArregloEmpresas] = useState({})
  const [ultimaIncidencia, setUltimaIndicencia] = useState({})
  const [operatividadActual, setOperatividadActual] = useState({})
  const [alertasTotalizado, setAlertasTotalizado] = useState([])
  const [seguimientosEmpresa, setSeguimientosEmpresa] = useState([])

  const {stateUser} = useContext(UserContext)
  const uid = stateUser.uid

  const listarEmpresas = async () => {
    const response = await Fetch({
      url :urlApiPlamin + '/listadoGeneralEmpresasCentroMonitoreo'
    })
    if(response.isValid){
      const jsondata = response.content
      const agrupadoPorEmpresa = Object.groupBy(jsondata, elem => elem.codEmpresa && elem.nomEmpresa)
      setArregloEmpresas(agrupadoPorEmpresa)
    }else{
      notify(response.exceptions[0].description, 'error')
    }
  }

  const listarUltimasIncidencias = async (codigoEmpresa = 0) => {
    const response = await Fetch({
      url :urlApiPlamin + '/listaIncidencias?CodEmpresa=' + codigoEmpresa
    })
    if(response.isValid){
      const jsondata = response.content
      setUltimaIndicencia(jsondata?.[0] || {})
    }else{
      notify(response.exceptions[0].description, 'error')
    }
  }

  const listarIndicadoresDeOperacion = async () => {
    const response = await Fetch({
      url: urlApiPlamin + '/listaOperatividad'
    })
    if(response.isValid){
      setOperatividadActual(response.content)
    }else{
      notify(response.exceptions[0].description, 'error')

    }
  }

  const listarAlertasTotalizado = async (codEmpresa = 0) => {
    const response = await Fetch({
      url: urlApiPlamin + '/listaAlertasGeneral?CodEmpresa=' + codEmpresa
    })
    if(response.isValid){
      setAlertasTotalizado(response.content)
    }else{
      notify(response.exceptions[0].description, 'error')
    }
  }

  const listarSeguimientosEmpresa = async (fechaInicio, fechaFin, codEmpresa, codRuta) => {
    const response = await  Fetch({
      url: urlApiPlamin + '/seguimientosAlerta?' + new URLSearchParams({
        fechaInicio: fechaInicio,
        fechaFin: fechaFin,
        codEmpresa: codEmpresa,
        codRuta: codRuta
      })
    })
    if(response.isValid){
      setSeguimientosEmpresa(response.content)
    }else{
      notify(response.exceptions[0].description, 'error')
    }
  }

  const registrarSeguimientoEmpresa = async (codEmpresa, codRuta, nomRuta, descripcion) => {
    const response = await Fetch({
      url: urlApiPlamin + '/seguimientosAlerta',
      method: 'POST',
      body: JSON.stringify({
        UIDAccion: uid,
        CodEmpresa: codEmpresa,
        CodRuta: codRuta,
        Descripcion: descripcion,
        NomRuta: nomRuta
      })
    });
    return {
      CodResultado : response.isValid ? 1 : 0,
      DesResultado : response.isValid ? response.content : response.exceptions[0].description
    }
  }

  const eliminarSeguimientoEmpresa = async (codigoSeguimiento) => {
    const response = await Fetch({
      url: urlApiPlamin + '/seguimientosAlerta',
      method: 'DELETE',
      body: JSON.stringify({
        UIDAccion: uid,
        CodIndicadorSeguimiento: codigoSeguimiento
      })
    })
    return {
      CodResultado : response.isValid ? 1 : 0,
      DesResultado : response.isValid ? response.content : response.exceptions[0].description
    }
  }

  return {
    listarEmpresas,
    arregloEmpresas,
    listarUltimasIncidencias,
    ultimaIncidencia,
    listarIndicadoresDeOperacion,
    operatividadActual,
    listarAlertasTotalizado,
    alertasTotalizado,
    listarSeguimientosEmpresa,
    seguimientosEmpresa,
    registrarSeguimientoEmpresa,
    eliminarSeguimientoEmpresa
  }
}
